export const hydrateTask = (task: APITask, types, statuses, priorities) => {
  const type = types.find(({ id }) => task.type_id === id)
  const status = statuses.find(({ id }) => task.status_id === id)
  const priority = priorities.find(({ id }) => task.priority_id === id)

  const hydrated: LocalTask = {
    ...task,
    commentsLoaded: false,
    subtasksLoaded: false,
    type: type?.name || '',
    status: status?.name || '',
    priority: priority || {},
    created_at: task.created_at ?? new Date().toISOString(),
    due_date: task.due_date ?? new Date().toISOString()
  }

  return hydrated
}

export const dehydrateTask = (task: LocalTask) => {
  const dehydrated: TaskUpdate = {
    assignee_ids: (task.assignee_ids ?? []).filter(Boolean),
    category_id: task.category_id || null,
    // @ts-ignore
    concerning_user_id: task.concerning_user_id ?? null,
    details: task.details || null,
    due_date: task.due_date ?? new Date().toISOString(),
    media_ids: task.media_ids ?? [],
    parent_id: task.parent_id ?? null,
    primary_assignee_id: task.primary_assignee_id || null,
    priority_id: task.priority_id || null,
    session_ids: (task.session_ids ?? []).filter(Boolean),
    status_id: task.status_id || null,
    tags: (task.tags ?? []).filter(Boolean),
    title: task.title,
    type_id: task.type_id || null,
    watcher_ids: (task.watcher_ids ?? []).filter(Boolean),
    closed_at: task.closed_at ?? null,
    team_id: task.team_id ?? null,
    sort_order: task.sort_order ?? 0,
    owner_id: task.owner_id ?? null,
    completed_at: task.completed_at ?? null
  }

  return dehydrated
}

export const mockComment = (
  comment: string,
  userID: string,
  taskID: string
) => {
  const mocked: APIComment = {
    id: 'TEMP',
    stamp: new Date().toISOString(),
    user_id: userID,
    content: comment,
    deleted_at: null,
    task_id: taskID
  }

  return mocked
}

export const createDataObject = async (
  values,
  mediaIds,
  session,
  newUserName,
  uploadUser
) => {
  const {
    primary,
    primary_assignee_id,
    due_date,
    status,
    type,
    watchers,
    tags,
    priority,
    client,
    section,
    parent_id,
    session_ids,
    id,
    title,
    team_id,
    content,
    sort_order,
    owner_id
  } = values

  const trimmedDate = new Date(due_date).toISOString()
  const assignee_ids = primary ? primary : []

  let concerning_user_id = client
  if (['', null].includes(client)) {
    if (newUserName) {
      const newUser = await new Promise((resolve, _) => {
        uploadUser(
          {
            name: newUserName,
            role_id: null,
            avatar_id: null,
            status_id: null
          },
          false,
          resolve
        )
      })
      //@ts-expect-error
      concerning_user_id = newUser.id
    } else {
      concerning_user_id = null
    }
  }

  const data = {
    title,
    details: content || null,
    due_date: trimmedDate || null,
    status_id: status === '' ? null : status,
    category_id: section === '' ? null : section,
    priority_id: priority === '' ? null : priority,
    type_id: type === '' ? null : type,
    tags,
    team_id,
    assignee_ids,
    media_ids: mediaIds,
    primary_assignee_id,
    session_ids: (session
      ? [session]
      : session_ids
      ? [session_ids[0]]
      : []
    ).filter(Boolean),
    watcher_ids: watchers,
    concerning_user_id,
    parent_id: parent_id ?? null,
    id,
    sort_order,
    owner_id
  }

  return data
}
